<template>
  <div>
    <el-drawer :visible.sync="show" direction="rtl">
      <h3 style="margin-left: 10px">Estadísticas</h3>
      <div style="margin-left: 20px">Servicios de hoy: {{ stats.servicesToday }}</div>
      <div style="margin-left: 20px">Servicios de ayer: {{ stats.servicesYesterday }}</div>
      <div style="margin-left: 20px">Taxis totales en flota: {{ stats.taxisFleet }}</div>
      <div style="margin-left: 20px">Taxis encendidos: {{ stats.taxisOn }}</div>
      <div style="margin-left: 20px">Taxis en parada: {{ stats.taxisInStop }}</div>
      <div style="margin-left: 20px">Taxis libres en zona: {{ stats.taxisInZoneFree }}</div>
      <div style="margin-left: 20px">Taxis finalizando: {{ stats.taxisNF }}</div>
      <div style="margin-left: 20px">
        Taxis con servicio de calle: {{ stats.taxisHandTrip }}
      </div>
      <div style="margin-left: 20px">
        Taxis con servicio de central: {{ stats.taxisCentralTrip }}
      </div>
    </el-drawer>

    <el-button class="share-button notification p-0" type="text">
      <i class="el-icon-s-data large" @click="click" />
      <label class="label-menu-item">Estadist</label>
    </el-button>
  </div>
</template>

<script>
import ApiClient from "@/api/ApiClient.ts";

export default {
  name: "Stats",

  data() {
    return {
      show: false,
      stats: {
        servicesToday: 0,
        servicesYesterday: 0,
        taxisFleet: 0,
        taxisOn: 0,
        taxisInStop: 0,
        taxisInZoneFree: 0,
        taxisNF: 0,
        taxisHandTrip: 0,
        taxisCentralTrip: 0,
      },
    };
  },
  watch: {
    show() {
      if (this.show) {
        this.getStats();
      }
    },
  },
  created() {},
  methods: {
    getStats() {
      ApiClient()
        .get("/stats", {
          params: {
            wgId: this.$store.getters.wgId,
            centralId: this.$store.getters.centralId,
          },
        })
        .then((response) => {
          this.stats = response.data;
        });
    },
    click() {
      this.show = true;
      this.getStats();
    },
    onClose() {
      this.show = false;
    },
  },
};
</script>

<style scoped>
.large {
  font-size: 200%;
}

i {
  display: block;
}

.label-menu-item {
  font-size: 0.5rem;
}
</style>
